import Axios from 'axios';
import Config from './Config.json';

const apiUrl = Config.strapi.protocol + '://' + Config.strapi.address + ':' + Config.strapi.port;
let gameRequest;

export function getGame() {
    if (!gameRequest) {
        gameRequest = Axios.get(apiUrl + '/games/' + encodeURIComponent(Config.website.gameId))
            .then(response => response.data)
            .catch(error => {
                gameRequest = undefined;
                throw error;
            });
    }
    return gameRequest;
}

export async function getGameNavigation(section) {
    const game = await getGame();
    const relation = game[section];
    const id = relation && (typeof relation === 'string' ? relation : relation.id || relation._id);
    if (!id) {
        return null;
    }
    // Fetch the related record to populate its links and images completely.
    const response = await Axios.get(apiUrl + '/headers/' + encodeURIComponent(id));
    return response.data;
}
